import React from 'react';
import { ReconcileUIProvider } from './ReconcileUIContext';
import { ReconcileCard } from './ReconcileCard'

export function ReconcilePage({ history }) {

	const reconcileUIEvents = {
		newReconcileClick: () => {
			history.push('/settlement/settlement/new');
		},
		openChooseReconcilePage: (id) => {
			history.push(`/settlement/settlement/${id}/choose`);
		},
		openEditReconcilePage: (id) => {
			history.push(`/settlement/settlement/${id}/edit`);
		}
	}

	return (
		<ReconcileUIProvider reconcileUIEvents={reconcileUIEvents} history={history} >
			<ReconcileCard />
		</ReconcileUIProvider>
	);
}

